/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxSolutionGetSolutionListType = typeof UtxSolutionGetSolutionListType[keyof typeof UtxSolutionGetSolutionListType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxSolutionGetSolutionListType = {
  UTGL_ACCOUNT_UPGRADE: 'UTGL_ACCOUNT_UPGRADE',
  UTGL_VIRTUAL_CARD_APPLICATION: 'UTGL_VIRTUAL_CARD_APPLICATION',
  UTGL_ONBOARDING: 'UTGL_ONBOARDING',
  UZPAY_ONBOARDING: 'UZPAY_ONBOARDING',
  UTGL_LEGACY: 'UTGL_LEGACY',
} as const;
